export const sumOf = (list) => {
  const temp = list
    .map((listItem) => listItem)
    .reduce((sum, value) => sum + value, 0);
  //console.log(inflowTotal / 100);
  return temp;
};
